import { useState, useContext } from 'react'
import "./Header.scss"
import { HeaderHeading } from '../../../Context'
import { RightSide } from './components/RightSide';
import { StoreListType } from './interface';

const Header: React.FC<{storeList: StoreListType}> = ({ storeList }) => {
  const { header }: any = useContext(HeaderHeading);

  return (
    <div className="s-layout">
      <main className="s-layout__content header-bg justify-content-between">
        <h3 className="mb-0 mx-lg-0 mx-3 fs-24 font-size-12 fw-700"> {header}</h3>
        <div className="me-lg-4 d-flex ">
          <RightSide
            storeList={storeList}
          />
        </div>
      </main>
    </div>
  )
}

export default Header

